import * as React from "react";
import Svg, { G, Path, Circle, Defs, ClipPath, Rect } from "react-native-svg";
const SVGComponent = (props) => (
    <Svg
        width={props.size || 25}
        height={props.size || 24}
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <G clipPath="url(#clip0_3875_43349)">
            <Path
                d="M14.5 3V7C14.5 7.26522 14.6054 7.51957 14.7929 7.70711C14.9804 7.89464 15.2348 8 15.5 8H19.5"
                stroke={props.color || "#667085"}
                strokeWidth={1.2}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <Path
                d="M17.5 21H7.5C6.96957 21 6.46086 20.7893 6.08579 20.4142C5.71071 20.0391 5.5 19.5304 5.5 19V5C5.5 4.46957 5.71071 3.96086 6.08579 3.58579C6.46086 3.21071 6.96957 3 7.5 3H14.5L19.5 8V19C19.5 19.5304 19.2893 20.0391 18.9142 20.4142C18.5391 20.7893 18.0304 21 17.5 21Z"
                stroke={props.color ||"#667085"}
                strokeWidth={1.2}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <Path
                d="M14.8672 10.5977L10.1172 17.8477"
                stroke={props.color ||"#667085"}
                strokeWidth={1.2}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <Circle
                cx={10.3672}
                cy={11.8477}
                r={1.25}
                stroke={props.color ||"#667085"}
                strokeWidth={1.2}
            />
            <Circle
                cx={14.8672}
                cy={16.3477}
                r={1.25}
                stroke={props.color ||"#667085"}
                strokeWidth={1.2}
            />
        </G>
        <Defs>
            <ClipPath id="clip0_3875_43349">
                <Rect width={24} height={24} fill="white" transform="translate(0.5)" />
            </ClipPath>
        </Defs>
    </Svg>
);
export default SVGComponent;
